import React, { useEffect, useState } from "react";
import { Col, Row, Input, Divider, Tooltip, Button, Card, Table, Collapse, Statistic, Image, Result, Alert } from "antd";
import Message from "../../Components/common/Message";
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import AuthService from "../../Components/auth/AuthService";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { deliveryStatuses } from "../../Components/common/Constants";
import { netsuite_url } from "../../Components/config";
import { Button as UploadButton } from "@mui/material";
import config from "../../Components/config";
import qs from "query-string";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CloseOutlined } from "@ant-design/icons";

const Auth = new AuthService();
const useStyles = makeStyles((theme) => ({
  
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "36px",
      height: "36px"
    },
    "& .ant-card .ant-card-body": {
      padding: "4px",
      // backgroundColor: 'rgb(240, 240, 240)',
    },
    "& .ant-statistic .ant-statistic-content": {
      fontSize: "12px",
      fontWeight: "bold",
    },
    "& .ant-statistic .ant-statistic-title": {
      fontSize: "12px",
    },
  }
}));

const Returns = () => {
  const { pinValidity } = useSelector((state) => state?.AppState?.driverData);
  const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const classes = useStyles();
  const dispatch = useDispatch();
  const securityPinExists = localStorage.getItem("securityPin");
  var layoutDispatch = useLoadingDispatch();

  const { Panel } = Collapse;
  const location = useLocation();
  const selectedDriverReturn = location?.state?.goodsReturnDriver;
  console.log('selectedDriverReturn', selectedDriverReturn);
  
  const filteredReturns = selectedDriverReturn?.map(obj => ({
    ...obj,
    items: obj?.items?.filter(item => item.item_id !== "Delivery Charge")
}));

  const [notes, setNotes] = useState("");
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/driver_returns/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const handleSaveReturns = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }
    if(currentItemFiles?.length < 1) {
      setType('error')
      setLoadMessage('Please add at least one file to proceed.' + str)
      return
    }
    const returnData = {
      driver_returns_notes: notes,
      driver_returns_files: currentItemFiles,
      route_status_id: selectedRoute,
    };
    setIsLoading(true)
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/driverapp/update-driver-returns-files", {
        method: "POST",
        body: JSON.stringify(returnData),
      });
      if (res.ack) {
        const uploadPromises = files.map(async (f, idx) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            console.error("Error uploading file:", error);
          }
        });

        Promise.all(uploadPromises);
        setLoadMessage(res.message)
        setType('success')
        navigate('/routes')
      } else {
        setLoadMessage(res.message)
        setType('error')
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
      hideLoading(layoutDispatch);
    }

  };

  const getGetDriverFiles = async () => {
    setIsLoading(true);
    
    try {
      const res = await Auth.fetch(`/driverapp/get-driver-returns-files?route_status_id=${selectedRoute}`);
      if (res?.ack) {
        console.log('res');
        setNotes(res?.driver_returns?.driver_returns_notes)
        setCurrentItemFiles(res?.driver_returns?.driver_returns_files ? JSON.parse(res?.driver_returns?.driver_returns_files ) : [])
      } else {
        setType('error')
        setLoadMessage(res?.message)
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    getGetDriverFiles()
  },[]);

  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  const columns = [
    {
      title: "S. No.",
      render: (_, __, index) => index + 1,
      width: 55
    },
    {
      title: "Item Name",
      dataIndex: "item_name",
      key: "item_name",
      width: 100
    },
    {
      title: "Item Code",
      dataIndex: "item_id",
      key: "item_id",
      width: 100
    },
    {
      title: "Ordered QTY",
      dataIndex: "quantity",
      key: "quantity",
      width: 55
      },
      {
        title: "Delivered QTY",
        dataIndex: "delivered_quantity",
        key: "delivered_quantity",
        width: 55
        },
      {
        title: "Returned QTY",
        dataIndex: "returned_quantity",
        key: "returned_quantity",
        render: (value) => value < 0 ? `+${-value}` : value,
        width: 55

      },
      {
        title: "Reason",
        // dataIndex: "delivery_status",
        // key: "delivery_status",
        render: (record) => {
            return record.delivery_status
              ? deliveryStatuses.filter((obj) => obj.id == record.delivery_status)[0]?.title
              : ""
          },
        width: 100
      },
  ];
  const defaultActiveKeys = filteredReturns.map((_, index) => index.toString());
  return (
    <div className={classes.dataSheet}>
      <Row style={{ display:"flex", justifyContent: 'start'}}>
        <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/routes")}>Back</Button>
        </Row>
        <div style={{ display: "flex", justifyContent: "space-between"}}>
         <h2 >Driver Returns</h2>
        </div>

        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <TextArea
              autoSize={{ minRows: 6, maxRows: 12 }}
              label="Notes"
              placeholder="Enter Any Specific Notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
            />
          </Col>
        </Row>
      </div>
      <div style={{ display: "flex"}}>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            accept="image/*, video/*"
            onChange={(e) => {
              handleSubmitImage(e);
            }}
          />
        </UploadButton>
      <Alert style={{ width: '180px', marginTop: "10px", marginLeft: "5px"}} message={'Images are required'} type="info" showIcon/>

      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/driver_returns/${selectedRoute}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                </div>
              );
            })}
      </Image.PreviewGroup>
      <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <Image.PreviewGroup>
        {files?.length > 0 &&
          files.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup>
      {files?.length > 0 && <Divider />}

      <div
        style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
      >
        <Button
          danger
          size="large"
          onClick={() => navigate("/routes")}
          style={{ marginRight: '5px'}}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          loading={isLoading}
          size="large"
          onClick={handleSaveReturns}
        >
          Save
        </Button>
        
      </div>
        <Divider />
        { filteredReturns?.length < 1 &&
          <Result status="404" subTitle="Sorry, no returns data to show." />
        }
        <>
        {
            filteredReturns?.length > 0 && filteredReturns?.map((data, index) =>(
                <>
                <Collapse style={{margin: '10px 0px'}} defaultActiveKey={defaultActiveKeys} >
              <Panel header={
              <>
        <Row gutter={[6, 16]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Card bordered style={{background: '#f0f0f0'}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Statistic
                title="Customer Name"
                value={data.customer_project_id}
                valueStyle={{
                  color: "#3f8600",
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>
              
              </>
              } key={index}>
                <Row gutter={[6, 16]}>
        <Col xs={8} sm={8} md={8} lg={4} xl={4}>
          <Card bordered style={{background: '#f0f0f0'}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Statistic
                title="Drop No."
                value={data.rank}
                valueStyle={{
                  color: "#3f8600",
                }}
              />
            </div>
          </Card>
        </Col>
        <Col xs={8} sm={8} md={8} lg={4} xl={4}>
          <Card bordered style={{background: '#f0f0f0'}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Statistic
                title="Shop Code"
                value={data.customer_name}
                valueStyle={{
                  color: "#3f8600",
                }}
              />
            </div>
          </Card>
        </Col>
        <Col xs={8} sm={8} md={8} lg={4} xl={4}>
          <Card bordered style={{background: '#f0f0f0'}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Statistic
                title="Invoice No."
                value={data.invoice_no}
                valueStyle={{
                  color: "#3f8600",
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>
              
              <Table
                  style={{ overflowX: "auto", marginTop: "10px"}}
                  columns={columns}
                  bordered
                  dataSource={data?.items}
                  pagination={false}
                  scroll={{
                    y: 400,
                  }}
                />
              </Panel>
              </Collapse>
              <Divider style={{ height: "2px", background: "#006cb8" }} />
                </>
            ))
        }
        </>

      <Message type={type} msg={loadMessage} />
    </div>
  );
};

export default Returns;
